"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddAdditionalRowDropdown = void 0;
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AddAdditionalRowDropdown = function AddAdditionalRowDropdown(_ref) {
  var classes = _ref.classes,
    additionalRowProps = _ref.additionalRowProps;
  var dropdownRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !(additionalRowProps !== null && additionalRowProps !== void 0 && additionalRowProps.openAdditionalRowDropdown) ? /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
    colSpan: additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.columns.length,
    className: additionalRowProps !== null && additionalRowProps !== void 0 && additionalRowProps.data.length ? classes.addAdditionalRow : classes.addAdditionalRowDisabled,
    onClick: function onClick() {
      return (additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.data.length) && (additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.setOpenAdditionalRowDropdown(true));
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proRegularSvgIcons.faPlusCircle,
    color: additionalRowProps !== null && additionalRowProps !== void 0 && additionalRowProps.data.length ? '#1E8777' : '#00000080'
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: additionalRowProps !== null && additionalRowProps !== void 0 && additionalRowProps.data.length ? '#1E8777' : '#00000080',
      marginLeft: '20px',
      fontSize: '13px'
    }
  }, additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.text))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
    ref: dropdownRef
  }, /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
    colSpan: additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.columns.length,
    className: classes.addAdditionalRow,
    onClick: function onClick() {
      return additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.setOpenAdditionalRowDropdown(false);
    },
    style: {
      backgroundColor: '#F7F7F7',
      color: '#00000080',
      boxShadow: '0px -2px 4px rgba(0, 0, 0, 0.05)'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proRegularSvgIcons.faInfoCircle,
    color: "#00000080"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: '#00000080',
      marginLeft: '8px',
      fontSize: '13px'
    }
  }, additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.dropdownText))), additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
      key: index,
      className: classes.additionalRowSelect
      // onclick has to be on the last column of a row
      ,
      onClick: item[additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.columns[(additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.columns.length) - 1].accessor].onClick
    }, additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.columns.map(function (column, colIndex) {
      if (item[column.accessor].colSpan === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
        key: colIndex,
        className: column.columnStyle,
        colSpan: item[column.accessor].colSpan || 1,
        style: {
          textAlign: item[column.accessor].textAlign || 'left'
        }
      }, item[column.accessor].value);
    }));
  })));
};
exports.AddAdditionalRowDropdown = AddAdditionalRowDropdown;
var _default = AddAdditionalRowDropdown;
exports["default"] = _default;